var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMediumTimeDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4254 39.3432C24.4165 35.6854 24.4165 16.6388 24.4254 12.9825C24.4254 12.6029 24.5913 12.2418 24.8845 11.9841C25.1763 11.7278 25.5674 11.6004 25.9628 11.6329C33.3599 12.3112 39.535 17.8439 39.535 26.1621C39.535 34.4803 33.3599 40.013 25.9628 40.6927C25.5674 40.7253 25.1763 40.5964 24.8845 40.3401C24.5913 40.0838 24.4254 39.7213 24.4254 39.3432Z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6417 44.2008C34.7489 44.2008 42.8852 36.1622 42.8852 26.3158C42.8852 16.4695 34.7489 8.43086 24.6417 8.43086C16.2638 8.43086 9.22817 13.9619 7.07686 21.4648C6.79498 22.448 5.76947 23.0165 4.78633 22.7346C3.8032 22.4527 3.23473 21.4272 3.51662 20.444C6.12213 11.3569 14.6071 4.72715 24.6417 4.72715C36.7312 4.72715 46.5889 14.3615 46.5889 26.3158C46.5889 38.2702 36.7312 47.9045 24.6417 47.9045C14.5597 47.9045 6.04179 41.2119 3.48001 32.0584C3.20436 31.0735 3.77933 30.0516 4.76423 29.776C5.74914 29.5003 6.77101 30.0753 7.04666 31.0602C9.16165 38.6173 16.2241 44.2008 24.6417 44.2008Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMediumTimeDark);
export default __webpack_public_path__ + "static/media/ic_medium_time_dark.cc5ca0fcaf3f0394f39d35fa4a652bb1.svg";
export { ForwardRef as ReactComponent };